// extracted by mini-css-extract-plugin
export var toggle = "Switch-module--toggle--qTWla";
export var focusVisible = "Switch-module--focus-visible--i-UTp";